import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme: any) => ({
  footer: {
    padding: theme.spacing(1.5),
    flexDirection: "row",
    background: "#1D4ED8",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "4px",
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1200,
    minHeight: "50px",
    height: "auto",
    [theme.breakpoints.down("sm")]: {
      position: "relative",
      marginTop: "auto",
    },
  },
}));
